import { useEffect, useState } from "react";
import { Button, Col, Flex, Form, Row, Select, Table } from "antd";

import { GET } from "../../../../providers/useAxiosQuery";
import { apiUrl, role } from "../../../../providers/companyInfo";
import {
	TablePagination,
	TableShowingEntriesV2,
	useTableScrollOnTop,
} from "../../../../providers/CustomTableFilter";

export default function CollapseItemGradeFileReportDetails(props) {
	const { location, dataDepartments, dataSchoolYear, dataSemester } = props;

	const [tableFilter, setTableFilter] = useState({
		page: 1,
		page_size: 50,
		search: "",
		sort_field: "fullname",
		sort_order: "asc",
		isTrash: 0,
		grade_file_type: "Without INC",
		department_ids: "",
		grade_file_status: "All",
		school_year_id: "",
		semester_id: "",
		quarter: "",
		from: "grade_file_report",
	});

	const { data: dataSource, refetch: refetchSource } = GET(
		`api/faculty_load?${new URLSearchParams(tableFilter)}`,
		"faculty_load_grade_file_list",
		() => {}
	);

	useEffect(() => {
		refetchSource();

		return () => {};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [tableFilter]);

	const onChangeTable = (pagination, filters, sorter) => {
		setTableFilter((prevState) => ({
			...prevState,
			sort_field: sorter.columnKey,
			sort_order: sorter.order ? sorter.order.replace("end", "") : null,
			page: 1,
		}));
	};

	const onFinish = (values) => {
		setTableFilter((prevState) => ({
			...prevState,
			department_ids: values.department_ids ? values.department_ids : "",
			school_year_id: values.school_year_id ? values.school_year_id : "",
			semester_id: values.semester_id ? values.semester_id : "",
			quarter: values.quarter ? values.quarter : "",
			grade_file_status: values.grade_file_status
				? values.grade_file_status
				: "All",
			grade_file_type: values.grade_file_type
				? values.grade_file_type
				: "Without INC",
			page: 1,
		}));
	};

	const handlePrintPdf = () => {
		window.open(
			apiUrl(
				`api/faculty_load_report_print?${new URLSearchParams(tableFilter)}`
			),
			"_blank"
		);
	};

	useTableScrollOnTop("tbl_grade_file", location.pathname);

	return (
		<Row gutter={[20, 20]} id="tbl-grade-file-wrapper">
			<Col xs={24} sm={24} md={24} lg={24}>
				<Form
					onFinish={onFinish}
					initialValues={{
						grade_file_status: "All",
						grade_file_type: "Without INC",
					}}
				>
					<Row gutter={[20, 20]}>
						<Col xs={24} sm={24} md={12} lg={6}>
							<Form.Item name="grade_file_status" noStyle>
								<Select
									placeholder="Status"
									className="w-100"
									size="large"
									allowClear
									showSearch
									filterOption={(input, option) => {
										// console.log("option", option);
										return (
											option.label.toLowerCase().indexOf(input.toLowerCase()) >=
											0
										);
									}}
									options={[
										{ label: "All", value: "All" },
										{ label: "Approval", value: "Uploaded" },
										{ label: "Approved", value: "Approved" },
										{ label: "No Upload", value: "NoUpload" },
									]}
								/>
							</Form.Item>
						</Col>
						<Col xs={24} sm={24} md={12} lg={6}>
							<Form.Item name="grade_file_type" noStyle>
								<Select
									placeholder="Type"
									className="w-100"
									size="large"
									allowClear
									showSearch
									filterOption={(input, option) => {
										// console.log("option", option);
										return (
											option.label.toLowerCase().indexOf(input.toLowerCase()) >=
											0
										);
									}}
									options={[
										{ label: "Without INC", value: "Without INC" },
										{ label: "With INC", value: "With INC" },
									]}
								/>
							</Form.Item>
						</Col>
						<Col xs={24} sm={24} md={12} lg={6}>
							{role() !== 3 ? (
								<Form.Item name="department_ids" noStyle>
									<Select
										placeholder="Department"
										className="w-100"
										size="large"
										allowClear
										showSearch
										filterOption={(input, option) => {
											// console.log("option", option);
											return (
												option.label
													.toLowerCase()
													.indexOf(input.toLowerCase()) >= 0
											);
										}}
										mode="multiple"
										options={dataDepartments.map((item) => {
											return {
												label: item.department_name,
												value: item.id,
											};
										})}
									/>
								</Form.Item>
							) : null}
						</Col>
						<Col xs={24} sm={24} md={6}>
							<Form.Item name="school_year_id" noStyle>
								<Select
									placeholder="School Year"
									className="w-100"
									size="large"
									allowClear
									showSearch
									filterOption={(input, option) => {
										// console.log("option", option);
										return (
											option.label.toLowerCase().indexOf(input.toLowerCase()) >=
											0
										);
									}}
									options={dataSchoolYear.map((item) => ({
										label: `${item.sy_from} - ${item.sy_to}`,
										value: item.id,
									}))}
								/>
							</Form.Item>
						</Col>

						<Col xs={24} sm={24} md={6}>
							<Form.Item name="semester_id" noStyle>
								<Select
									placeholder="Semester"
									className="w-100"
									size="large"
									allowClear
									showSearch
									filterOption={(input, option) => {
										// console.log("option", option);
										return (
											option.label.toLowerCase().indexOf(input.toLowerCase()) >=
											0
										);
									}}
									options={dataSemester.map((item) => ({
										label: item.semester,
										value: item.id,
									}))}
								/>
							</Form.Item>
						</Col>

						<Col xs={24} sm={24} md={6}>
							<Form.Item name="quarter" noStyle>
								<Select
									placeholder="Quarter"
									className="w-100"
									size="large"
									allowClear
									showSearch
									filterOption={(input, option) => {
										// console.log("option", option);
										return (
											option.label.toLowerCase().indexOf(input.toLowerCase()) >=
											0
										);
									}}
									options={[
										{ label: "Midterm", value: "Midterm" },
										{ label: "Finals", value: "Finals" },
									]}
								/>
							</Form.Item>
						</Col>

						<Col xs={24} sm={24} md={24} lg={24}>
							<Flex justify="space-between" align="center">
								<Button className="btn-main-primary" htmlType="submit">
									Submit
								</Button>

								<Button
									className="btn-main-primary"
									onClick={() => handlePrintPdf()}
								>
									Generate Report
								</Button>
							</Flex>
						</Col>
					</Row>
				</Form>
			</Col>

			<Col xs={24} sm={24} md={14} lg={24}>
				<Table
					id="tbl_grade_file"
					className="ant-table-default ant-table-striped"
					dataSource={dataSource && dataSource.data ? dataSource.data.data : []}
					rowKey={(record) => record.id}
					pagination={false}
					bordered={false}
					onChange={onChangeTable}
					scroll={{ x: "max-content" }}
					sticky
				>
					<Table.Column
						title="Name"
						key="fullname"
						sorter
						dataIndex="fullname"
						width={220}
					/>
					<Table.Column
						title="Section"
						key="section"
						dataIndex="section"
						sorter
						width={180}
					/>
					<Table.Column
						title="Subject"
						key="code"
						dataIndex="code"
						sorter
						width={180}
					/>
					<Table.Column
						title="School Year"
						key="school_year"
						dataIndex="school_year"
						sorter
						width={180}
					/>
					<Table.Column
						title="Semester"
						key="semester"
						dataIndex="semester"
						sorter
						width={180}
					/>
					<Table.Column
						title="Status"
						key="gradeFileStatus"
						dataIndex="gradeFileStatus"
						sorter
						align="center"
						width={180}
					/>
				</Table>
			</Col>
			<Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
				<Flex justify="space-between" align="center" className="tbl-top-filter">
					<div />
					<Flex gap={10} align="center">
						<TableShowingEntriesV2 />

						<TablePagination
							tableFilter={tableFilter}
							setTableFilter={setTableFilter}
							total={
								dataSource && dataSource.data && dataSource.data.total > 0
									? dataSource.data.total
									: 0
							}
							showLessItems={true}
							showSizeChanger={false}
							tblIdWrapper="tbl-grade-file-wrapper"
						/>
					</Flex>
				</Flex>
			</Col>
		</Row>
	);
}
